import { render, staticRenderFns } from "./homeCoupon.vue?vue&type=template&id=db185094&scoped=true&"
import script from "./homeCoupon.vue?vue&type=script&lang=js&"
export * from "./homeCoupon.vue?vue&type=script&lang=js&"
import style0 from "./homeCoupon.vue?vue&type=style&index=0&id=db185094&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db185094",
  null
  
)

export default component.exports